(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAdresseEingabe', {
            require: {
                form: '^form'
            },
            bindings: {
                model: '<abaeModel',
                options: '<abaeOptions',
                onChange: '&abaeOnChange',
                disabled: '<abaeDisabled'
            },
            templateUrl: 'bloecke/adresse/blockAdresseEingabe.html',
            controller: BlockAdresseEingabeController,
            controllerAs: 'blockAdresseEingabeVm'
        });

    BlockAdresseEingabeController.$inject = [
        '$scope',
        '$q',
        '$timeout',
        'lodash',
        'MiscUtilsService',
        'AdresseUtilsService',
        'FormFieldUtilsService'
    ];
    function BlockAdresseEingabeController($scope, $q, $timeout, _, MiscUtilsService, AdresseUtilsService, FormFieldUtilsService) {
        var vm = this,
            formFieldNames = [
                'plz',
                'ort',
                'strasse_hausnummer',
                'plz_ort'
            ];

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.onChanged = onChanged;
        vm.onAdresseChangedByValidator = onAdresseChangedByValidator;
        vm.onAdresseValidatedByValidator = onAdresseValidatedByValidator;
        vm.existsPlz = existsPlz;
        vm.getOrte = getOrte;
        vm.getAdresseErrorObject = getAdresseErrorObject;
        vm.onAdresseSearchChange = onAdresseSearchChange;
        vm.onAdresseSearchInput = onAdresseSearchInput;

        vm.onPostleitzahlSearchChange = onPostleitzahlSearchChange;
        vm.onPostleitzahlSearchInput = onPostleitzahlSearchInput;

        function activate() {
            vm.isLoadingOrt = false;

            vm.model = vm.model || {};
            vm.options = vm.options || {};
            vm.placeholder = {
                strasse: ''
            };

            vm.orteZurPlz = [];

            vm.getOrte(_.get(vm.model, 'postleitzahl')).finally(function () {
                vm.disabledFields = {
                    postleitzahl: false,
                    ort: false,
                    strasse: false
                };

                vm.modelStrasseHausnummer = vm.model.strasse;
                vm.modelPostleitzahlOrt = _.compact([vm.model.postleitzahl, vm.model.ort]).join(' ');

                setPlaceholder();
                checkDisabled();

                vm.typeaheadStrasseHausnummer = {
                    promise: function (options) {
                        return $q(function (resolve, reject) {
                            return AdresseUtilsService.search(
                                {
                                    ort: vm.model.ort,
                                    postleitzahl: vm.model.postleitzahl,
                                    strasse: options.filter
                                }, 'strasse'
                            ).then(function (data) {
                                if (vm.disabledFields.postleitzahl) {
                                    return resolve(_.reject(data, function (item) {
                                        return item.postalcode !== vm.model.postleitzahl;
                                    }));
                                } else {
                                    return resolve(data);
                                }
                            }).catch(function (error) {
                                reject(error);
                            }).finally(function () {});
                        });
                    },
                    options: {
                        displayTemplate: '<%= data.street %><% if (!_.isEmpty(data.number)) { %> <%= data.number %><%}%><% if (data.searchData) {var arr = []; if (data.searchData.postleitzahl != data.postalcode && data.postalcode) { arr.push(data.postalcode); } if (data.searchData.ort != data.city && data.city) { arr.push(data.city) } if (arr.length > 0) { %> (<%= arr.join(" ")%>)<%}}%>',
                        displayTemplateData: {
                            searchData: {
                                postleitzahl: vm.model.postleitzahl,
                                ort: vm.model.ort
                            }
                        },
                        placeholder: vm.placeholder.strasse,
                        displayStyle: 'popover',
                        filterLocal: false,
                        unifySearchTerm: false,
                        useSearchTermOnHttpError: true,
                        useSearchTermOnNoData: true,
                        directSelectOnNoData: true,
                        directSelectSingleExactMatch: true,
                        ariaErrorMessage: [
                            vm.adresseValidatorErrorId
                        ],
                        debounceTime: 0,
                        minSearchLength: 3,
                        validation: {
                            showMessageOnValidate: false
                        },
                        filterFn: function (data, searchTerm) {
                            var maxQualityObj = _.maxBy(data, function (o) {
                                return parseFloat(o.quality);
                            });

                            if (maxQualityObj && parseFloat(maxQualityObj.quality) < 85.0) {
                                data.push({ street: searchTerm });
                            }

                            return data;
                        }
                    }
                };

                vm.typeaheadPostleitzahl = {
                    promise: function (options) {
                        return $q(function (resolve, reject) {
                            return AdresseUtilsService.checkPlz(options.filter)
                            .then(function (data) {
                                resolve(data);
                            }).catch(function (error) {
                                reject(error);
                            }).finally(function () {});
                        });
                    },
                    options: {
                        displayTemplate: '<%= data.wert %> <%= data.bezeichnung %>',
                        displayProperty: '_bez',
                        placeholder: vm.placeholder.postleitzahl,
                        displayStyle: 'popover',
                        filterLocal: false,
                        unifySearchTerm: false,
                        useSearchTermOnHttpError: false,
                        useSearchTermOnNoData: false,
                        directSelectSingleExactMatch: true,
                        ariaErrorMessage: [
                            vm.adresseValidatorErrorId
                        ],
                        debounceTime: 0,
                        minSearchLength: 3,
                        trackingWithValue: true,
                        validation: {
                            showMessageOnValidate: false
                        },
                        filterFn: function (data, searchTerm) {
                            var match = searchTerm.match(/([0-9]{1,5})?\s?(.*)/);
                            if (match[1]) {
                                data = _.filter(data, function (item) {
                                    return item.wert.startsWith(match[1]);
                                });
                            } else if (match[2]) {
                                data = _.filter(data, function (item) {
                                    return item.bezeichnung.toLowerCase().startsWith(match[2].toLowerCase());
                                });
                            }

                            return data;
                        }
                    }
                };
            });
        }

        function onChanges(changes) {
            if (changes && changes.model && changes.model.isFirstChange()) {
                return;
            }

            if (changes && changes.disabled) {
                vm.origDisabled = changes.disabled.currentValue;
            }

            activate();
        }

        function onInit() {
            vm.options = vm.options || {};
            vm.uuid = MiscUtilsService.guid('#');
            vm.origDisabled = vm.disabled;
            vm.adresseValidatorErrorId = 'adresseValidatorError_' + vm.uuid;

            vm.formFieldNames = _.zipObject(formFieldNames, _.map(formFieldNames, function (fieldName) {
                return _.compact([
                    vm.options.namePrefix,
                    fieldName,
                    vm.options.namePrefix === undefined ? vm.uuid : null
                ]).join('_');
            }));

            activate();
        }

        function onChanged(key, value) {
            if (key === 'postleitzahl') {
                vm.orteZurPlz = [];
                vm.getOrte(value, true).then(function () {
                    setPlaceholder();
                    checkDisabled();

                    _.set(vm.typeaheadStrasseHausnummer, 'options.displayTemplateData.searchData.postleitzahl', vm.model.postleitzahl);
                    _.set(vm.typeaheadStrasseHausnummer, 'options.displayTemplateData.searchData.ort', vm.model.ort);
                });

                vm.model.ort = null;
                vm.model.strasse = null;
                resetStrasseSearch();
            } else {
                if (key === 'ort') {
                    vm.model.strasse = null;
                    resetStrasseSearch();
                    _.set(vm.typeaheadStrasseHausnummer, 'options.displayTemplateData.searchData.ort', vm.model.ort);
                }

                setPlaceholder();
                checkDisabled();
            }

            vm.onChange({ adresse: {} });
        }

        function onAdresseChangedByValidator(adresse, checkType, validationItems) {
            var isPlzOrtChanged = false;

            adresse = adresse || {};
            if (checkType === 'OK') {
                vm.onChange({ adresse: adresse });
                return;
            }

            vm.getOrte(adresse.postleitzahl, false).then(function () {
                if (_.indexOf(vm.orteZurPlz, adresse.ort) > -1) {
                    if (vm.model.postleitzahl !== adresse.postleitzahl) {
                        vm.model.postleitzahl = adresse.postleitzahl;
                        isPlzOrtChanged = true;

                        if (vm.options.disableSearchPostleitzahl === true) {
                            $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.plz], '$$element') ], {
                                force: true
                            });
                        }
                    }

                    if (vm.model.ort !== adresse.ort) {
                        vm.model.ort = adresse.ort;
                        isPlzOrtChanged = true;

                        if (vm.options.disableSearchPostleitzahl === true) {
                            $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.ort], '$$element') ], {
                                force: true
                            });
                        }
                    }

                    if (isPlzOrtChanged && vm.options.disableSearchPostleitzahl !== true) {
                        $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.plz_ort], '$$element') ], {
                            force: true
                        });
                    }

                    if (vm.model.strasse !== adresse.strasse) {
                        vm.model.strasse = adresse.strasse;

                        $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.strasse_hausnummer], '$$element') ], {
                            force: true
                        });
                    }
                } else {
                    vm.model.ort = null;
                    vm.model.strasse = null;

                    if (vm.options.disableSearchPostleitzahl === true) {
                        $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.ort], '$$element') ], {
                            force: true
                        });
                    }

                    $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.strasse_hausnummer], '$$element') ], {
                        force: true
                    });

                    resetStrasseSearch();
                }

                vm.origDisabled = false;
                vm.modelStrasseHausnummer = vm.model.strasse;
                vm.modelPostleitzahlOrt = _.compact([vm.model.postleitzahl, vm.model.ort]).join(' ');

                setPlaceholder();
                checkDisabled();
            });
        }

        function onAdresseValidatedByValidator() {
            FormFieldUtilsService.setValidity([vm.form[vm.formFieldNames.strasse_hausnummer]], 'typeahead', true);
            FormFieldUtilsService.setValidity([vm.form[vm.formFieldNames.plz_ort]], 'typeahead', true);
            checkDisabled();
        }

        function setPlaceholder() {
            if (MiscUtilsService.isEmpty(vm.model.postleitzahl)) {
                if (vm.options.disableSearchPostleitzahl === true) {
                    vm.placeholder.strasse = vm.placeholder.ort = 'Bitte zuerst Postleitzahl eingeben';
                } else {
                    vm.placeholder.strasse = 'Bitte zuerst Postleitzahl und Ort eingeben';
                }
            } else if (MiscUtilsService.isEmpty(vm.model.ort) && _.size(vm.orteZurPlz) > 1) {
                vm.placeholder.ort = 'Bitte wählen Sie';
                vm.placeholder.strasse = 'Bitte zuerst Ort auswählen';
            } else {
                if (_.size(vm.orteZurPlz) > 1) {
                    vm.placeholder.ort = 'Bitte wählen Sie';
                } else {
                    vm.placeholder.ort = '';
                }
                vm.placeholder.strasse = '';
            }

            _.set(vm.typeaheadStrasseHausnummer, 'options.placeholder', vm.placeholder.strasse);
        }
        function existsPlz(postleitzahl) {
            return $q(function (resolve, reject) {
                return AdresseUtilsService.existsPlz(postleitzahl).then(function (postleitzahlen) {
                    resolve(postleitzahlen);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
        function getOrte(postleitzahl, isChangeEvent) {
            if (MiscUtilsService.isEmpty(postleitzahl)) {
                setOrt();
                return $q.resolve([]);
            }
            if (isChangeEvent) {
                setOrt();
            }

            return $q(function (resolve, reject) {
                return AdresseUtilsService.existsPlz(postleitzahl).then(function (postleitzahlen) {
                    if (postleitzahlen.length === 1) {
                        vm.orteZurPlz = [_.get(postleitzahlen[0], 'bezeichnung')];
                        setOrt(postleitzahlen[0]);
                    } else {
                        vm.orteZurPlz = _.map(postleitzahlen, 'bezeichnung');
                    }

                    if (!_.includes(vm.orteZurPlz, vm.model.ort)) {
                        setOrt();
                    }

                    if (isChangeEvent && vm.options.disableSearchPostleitzahl === true) {
                        $timeout(function () {
                            if (_.size(vm.orteZurPlz) === 1) {
                                $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.ort], '$$element') ], {
                                    force: true
                                });
                            }
                        });
                    }
                    return resolve(postleitzahlen);
                }).catch(function (error) {
                    vm.orteZurPlz = [];
                    setOrt({});

                    return reject(error);
                }).finally(function () {
                });
            }).catch(function (error) {});
        }
        function setOrt(ort) {
            vm.model.ort = _.get(ort, 'bezeichnung');
        }

        function checkDisabled() {
            _.set(vm.typeaheadStrasseHausnummer, 'options.tabindex', 0);
            _.set(vm.typeaheadStrasseHausnummer, 'options.readonly', false);
            _.set(vm.typeaheadPostleitzahl, 'options.tabindex', 0);
            _.set(vm.typeaheadPostleitzahl, 'options.readonly', false);

            if (
                vm.origDisabled
            ) {
                vm.disabledFields.postleitzahl = true;
                vm.disabledFields.ort = true;
                vm.disabledFields.strasse = true;
                vm.disabled = true;

                _.set(vm.typeaheadStrasseHausnummer, 'options.tabindex', -1);
                _.set(vm.typeaheadStrasseHausnummer, 'options.readonly', true);
                _.set(vm.typeaheadPostleitzahl, 'options.tabindex', -1);
                _.set(vm.typeaheadPostleitzahl, 'options.readonly', true);
                return;
            } else {
                vm.disabled = false;
                vm.disabledFields.postleitzahl = false;
            }

            if (MiscUtilsService.isEmpty(vm.model.postleitzahl) || _.size(vm.orteZurPlz) === 0) {
                vm.disabledFields.ort = true;
                vm.disabledFields.strasse = true;
            } else if (MiscUtilsService.isEmpty(vm.model.ort)) {
                vm.disabledFields.ort = false;
                vm.disabledFields.strasse = true;
            } else if (MiscUtilsService.isEmpty(vm.model.strasse)) {
                vm.disabledFields.ort = false;
                vm.disabledFields.strasse = false;
            } else {
                vm.disabledFields.ort = false;
                vm.disabledFields.strasse = false;
            }

            if (_.size(vm.orteZurPlz) === 1) {
                vm.disabledFields.ort = true;
            }
            if (_.get(vm.options.disabled, 'postleitzahl')) {
                vm.disabledFields.postleitzahl = true;
            }

            if (_.get(vm.options.disabled, 'ort')) {
                vm.disabledFields.ort = true;
            }

            if (_.get(vm.options.disabled, 'strasse')) {
                vm.disabledFields.strasse = true;
            }

            _.set(vm.typeaheadStrasseHausnummer, 'options.readonly', vm.disabledFields.strasse);
            _.set(vm.typeaheadPostleitzahl, 'options.readonly', vm.disabledFields.postleitzahl);
        }
        function getAdresseErrorObject(errorObjects) {
            return AdresseUtilsService.getAdresseErrorObject(errorObjects);
        }

        function onAdresseSearchChange(value, matches) {
            var isPlzOrtChanged = false;

            if (value) {
                _.set(vm.model, 'strasse', _.compact([value.street, value.number]).join(' ') || value.bezeichnung);

                if (value.city && _.get(vm.model, 'ort') !== value.city) {
                    _.set(vm.model, 'ort', value.city);
                    isPlzOrtChanged = true;

                    if (vm.options.disableSearchPostleitzahl === true) {
                        $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.ort], '$$element') ], {
                            force: true,
                            state: 'normal'
                        });
                    }
                }

                if (value.postalcode && _.get(vm.model, 'postleitzahl') !== value.postalcode) {
                    _.set(vm.model, 'postleitzahl', value.postalcode);
                    isPlzOrtChanged = true;

                    if (vm.options.disableSearchPostleitzahl === true) {
                        $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.plz], '$$element') ], {
                            force: true,
                            state: 'normal'
                        });
                    }
                }

                _.set(vm.typeaheadStrasseHausnummer, 'options.displayTemplateData.searchData.postleitzahl', vm.model.postleitzahl);
                _.set(vm.typeaheadStrasseHausnummer, 'options.displayTemplateData.searchData.ort', vm.model.ort);
                vm.modelPostleitzahlOrt = [vm.model.postleitzahl, vm.model.ort].join(' ');

                if (isPlzOrtChanged && vm.options.disableSearchPostleitzahl !== true) {
                    $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.plz_ort], '$$element') ], {
                        name: vm.formFieldNames.plz_ort,
                        force: true,
                        state: 'normal'
                    });
                }
            } else {
                _.set(vm.model, 'strasse', null);
            }
        }

        function onAdresseSearchInput() {
            FormFieldUtilsService.setValidity([vm.form[vm.formFieldNames.strasse_hausnummer]], 'typeahead', false);
        }

        function onPostleitzahlSearchChange(value, matches) {
            if (value) {
                if (_.get(vm.model, 'postleitzahl') !== value.wert) {
                    if (vm.options.disableSearchPostleitzahl === true) {
                        $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.plz], '$$element') ], {
                            force: true,
                            state: 'normal'
                        });
                    }
                }

                _.set(vm.model, 'postleitzahl', value.wert);
                onChanged('postleitzahl', value.wert);

                if (_.get(vm.model, 'ort') !== value.bezeichnung) {
                    if (vm.options.disableSearchPostleitzahl === true) {
                        $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.form[vm.formFieldNames.ort], '$$element') ], {
                            force: true,
                            state: 'normal'
                        });
                    }
                }

                _.set(vm.model, 'ort', value.bezeichnung);
                onChanged('ort', value.wert);

                setPlaceholder();
                checkDisabled();
            } else {
                _.set(vm.model, 'postleitzahl', null);
                _.set(vm.model, 'ort', null);
                _.set(vm.model, 'strasse', null);
                resetStrasseSearch();
                setPlaceholder();
                checkDisabled();
            }
        }

        function onPostleitzahlSearchInput() {
            FormFieldUtilsService.setValidity([vm.form[vm.formFieldNames.plz_ort]], 'typeahead', false);
            _.set(vm.model, 'strasse', null);
            resetStrasseSearch();
            setPlaceholder();
            checkDisabled();
        }

        function resetStrasseSearch() {
            vm.shouldResetStrasseSearch = true;

            $timeout(function () {
                vm.shouldResetStrasseSearch = false;
            });
        }
    }
})();
